import React, { useState, useEffect } from 'react';
import WrapperComponent from '../commonComponents/WrapperComponent';
import { url } from '../../util/config';
import TemplateViewComponent from '../commonComponents/TemplateView';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

const CreateCampaignComponent = () => {
    const navigate = useNavigate();
    const [templateCategory, setTemplateCategory] = useState('');
    const [templateOptions, setTemplateOptions] = useState([]);
    const [listOptions, setListOptions] = useState([]);
    const [templateType, setTemplateType] = useState([]);
    const [sendVia, setSendVia] = useState('oneToOne');
    const [uploadFile, setUploadFile] = useState(null);
    const [noInput, setNoInput] = useState('');
    const [noError, setNoError] = useState('');
    const [templateError, setTemplateError] = useState('');
    const [scheduleOption, setScheduleOption] = useState('sendNow');
    const [scheduleDate, setScheduleDate] = useState('');
    const [scheduleTime, setScheduleTime] = useState('');
    const [contactList, setContactList] = useState('');
    const [segmentList, setSegmentList] = useState('');
    const [templateCategoryOptions, setTemplateCategoryOptions] = useState([]);
    const [senderOptions, setSenderOptions] = useState([]);
    const [templateTypeOptions, setTemplateTypeOptions] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState('');
    const [sender, setSender] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        const fetchContactList = async () => {
            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${url}/contacts`, { method: 'GET', headers: { 'Authorization': 'Bearer ' + token } });
                if (!response.ok) throw new Error('Failed to fetch contact list');
                const data = await response.json();
                setListOptions(data);
            } catch (error) { console.error('Error fetching contact list:', error); }
        };
        fetchContactList();
    }, []);

    useEffect(() => {
        const fetchTemplateCategories = async () => {
            try {
                const response = await fetch(`${url}/templatecategory/false`);
                if (!response.ok) throw new Error('Failed to fetch template categories');
                const data = await response.json();
                setTemplateCategoryOptions(data);
            } catch (error) { console.error('Error fetching template categories:', error); }
        };
        fetchTemplateCategories();
    }, []);

    useEffect(() => {
        const fetchProfile = async () => {
            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${url}/profiles`, { method: 'GET', headers: { 'Authorization': 'Bearer ' + token } });
                if (!response.ok) throw new Error('Failed to fetch Whatsapp Profile');
                const data = await response.json();
                setSenderOptions(data);
            } catch (error) { console.error('Error fetching Whatsapp Profile:', error); }
        };
        fetchProfile();
    }, []);

    useEffect(() => {
        const fetchTemplateTypes = async () => {
            try {
                const response = await fetch(`${url}/templatetype/false`);
                if (!response.ok) throw new Error('Failed to fetch template type');
                const data = await response.json();
                setTemplateTypeOptions(data);
            } catch (error) { console.error('Error fetching template type:', error); }
        };
        fetchTemplateTypes();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const template_val = JSON.parse(document.getElementById('template').value);
            const temp_id = template_val._id;

            const formData = new FormData();
            formData.append('campaign_name', document.getElementById('campaignName').value);
            formData.append('template_category', templateCategory);
            formData.append('template', document.getElementById('template').value);
            formData.append('template_type', document.getElementById('templateType').value);
            formData.append('template_id', temp_id);
            formData.append('send_via', sendVia);
            formData.append('status', 0);
            formData.append('sender', sender);

            if (sendVia === 'oneToOne') {
                formData.append('base_url', document.getElementById('oneToOneInput').value);
            } else if (sendVia === 'fileUpload') {
                formData.append('base_url', document.getElementById('fileUploadInput').files[0]);
            } else if (sendVia === 'contactList') {
                formData.append('base_url', document.getElementById('contactlist').value);
            } else if (sendVia === 'segmentList') {
                formData.append('base_url', document.getElementById('segmentlist').value);
            }

            formData.append('country_code', '+91');
            formData.append('scheduleOption', scheduleOption);
            if (scheduleOption === 'sendNow') {
                formData.append('schedule_date', new Date().toISOString());
            } else if (scheduleOption === 'schedule') {
                if (scheduleDate && scheduleTime) {
                    formData.append('schedule_date', new Date(`${scheduleDate}T${scheduleTime}`).toISOString());
                } else {
                    console.error('Schedule date or time is missing.');
                }
            }

            const token = localStorage.getItem('token');
            const response = await fetch(`${url}/campaign`, {
                method: 'POST',
                headers: { Authorization: 'Bearer ' + token },
                body: formData,
            });

            e.target.reset();
            setTemplateCategory('');
            setTemplateOptions([]);
            setSendVia('oneToOne');
            setNoInput('');
            setNoError('');
            setScheduleOption('sendNow');
            setScheduleDate('');
            setScheduleTime('');

            if (!response.ok) {
                toast.error('Error creating Campaign', { autoClose: 3000 });
                return;
            }
            toast.success('Campaign created successfully!', { autoClose: 3000 });
            setTimeout(() => navigate('/campaign'), 3000);
        } catch (err) {
            console.error('Campaign creation error:', err);
            toast.error('An error occurred. Please try again.', { autoClose: 3000 });
        } finally {
            setIsSubmitting(false);
        }
    };

    const SEND_VIA_OPTIONS = [
        { value: 'oneToOne',    label: 'One to One',    icon: 'bi-person' },
        { value: 'contactList', label: 'Contact List',  icon: 'bi-people' },
        { value: 'fileUpload',  label: 'File Upload',   icon: 'bi-file-earmark-arrow-up' },
        { value: 'segmentList', label: 'Segment',       icon: 'bi-funnel' },
    ];

    const SCHEDULE_OPTIONS = [
        { value: 'sendNow',  label: 'Send Now',  icon: 'bi-send' },
        { value: 'schedule', label: 'Schedule',  icon: 'bi-calendar-event' },
    ];

    return (
        <WrapperComponent>
            <div style={f.page}>
                {/* Page header */}
                <div style={f.pageHeader}>
                    <div>
                        <h5 style={f.pageTitle}>Create New Campaign</h5>
                        <p style={f.pageSubtitle}>Set up a WhatsApp broadcast campaign</p>
                    </div>
                    <button type="button" style={f.btnSecondary} onClick={() => navigate('/campaign')}>
                        <i className="bi bi-arrow-left" style={{ marginRight: 6 }}></i>Back
                    </button>
                </div>

                <form onSubmit={handleSubmit} noValidate>
                    <div style={f.layout}>
                        {/* ── LEFT COLUMN ─────────────────────────── */}
                        <div style={f.leftCol}>

                            {/* Section 1 — Campaign Details */}
                            <div style={f.section}>
                                <div style={f.sectionHeader}>
                                    <span style={f.stepBadge}>1</span>
                                    <div>
                                        <p style={f.sectionTitle}>Campaign Details</p>
                                        <p style={f.sectionDesc}>Basic information about your campaign</p>
                                    </div>
                                </div>
                                <div style={f.sectionBody}>
                                    {/* Campaign Name */}
                                    <div style={f.fieldGroup}>
                                        <label style={f.label}>Campaign Name <span style={f.required}>*</span></label>
                                        <input
                                            type="text"
                                            id="campaignName"
                                            style={f.input}
                                            placeholder="Enter campaign name"
                                            required
                                        />
                                    </div>
                                    {/* Sender */}
                                    <div style={f.fieldGroup}>
                                        <label style={f.label}>WhatsApp Number <span style={f.required}>*</span></label>
                                        <select id="sender" style={f.input} value={sender} onChange={(e) => setSender(e.target.value)} required>
                                            <option value="">Select WhatsApp Number</option>
                                            {senderOptions.map((option, index) => (
                                                <option key={index} value={option.whatsapp_no}>{option.whatsapp_no}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {/* Section 2 — Template */}
                            <div style={f.section}>
                                <div style={f.sectionHeader}>
                                    <span style={f.stepBadge}>2</span>
                                    <div>
                                        <p style={f.sectionTitle}>Template Selection</p>
                                        <p style={f.sectionDesc}>Choose the message template for this campaign</p>
                                    </div>
                                </div>
                                <div style={f.sectionBody}>
                                    {/* Template Category */}
                                    <div style={f.fieldGroup}>
                                        <label style={f.label}>Template Category <span style={f.required}>*</span></label>
                                        <select id="templateCategory" style={f.input} value={templateCategory} onChange={(e) => setTemplateCategory(e.target.value)} required>
                                            <option value="">Select Category</option>
                                            {templateCategoryOptions.map((cat, index) => (
                                                <option key={index} value={cat.description}>{cat.description}</option>
                                            ))}
                                        </select>
                                    </div>
                                    {/* Template Type */}
                                    <div style={f.fieldGroup}>
                                        <label style={f.label}>Template Type <span style={f.required}>*</span></label>
                                        <select
                                            id="templateType"
                                            style={f.input}
                                            value={templateType}
                                            onChange={async (e) => {
                                                const selectedTemplateType = e.target.value;
                                                setTemplateType(selectedTemplateType);
                                                if (selectedTemplateType) {
                                                    try {
                                                        const response = await fetch(`${url}/templates?template_type=${selectedTemplateType}`, {
                                                            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
                                                        });
                                                        if (!response.ok) throw new Error('Failed to fetch templates');
                                                        const data = await response.json();
                                                        if (data.length === 0) setTemplateError('No templates found for the selected criteria.');
                                                        else setTemplateError('');
                                                        setTemplateOptions(data);
                                                    } catch (error) {
                                                        console.error('Error fetching templates:', error);
                                                        setTemplateOptions([]);
                                                        setTemplateError('Failed to fetch templates. Please try again.');
                                                    }
                                                } else {
                                                    setTemplateOptions([]);
                                                }
                                            }}
                                            required
                                        >
                                            <option value="">Select Template Type</option>
                                            {templateTypeOptions.map((type, index) => (
                                                <option key={index} value={type.description}>{type.description}</option>
                                            ))}
                                        </select>
                                        {templateError && <span style={f.fieldError}>{templateError}</span>}
                                    </div>
                                    {/* Template */}
                                    <div style={f.fieldGroup}>
                                        <label style={f.label}>Template <span style={f.required}>*</span></label>
                                        <select
                                            id="template"
                                            style={{ ...f.input, ...(templateOptions.length === 0 ? { background: '#f9fafb', color: '#9ca3af' } : {}) }}
                                            required
                                            disabled={templateOptions.length === 0}
                                            onChange={(e) => setSelectedTemplate(e.target.value)}
                                        >
                                            <option value="">{templateOptions.length === 0 ? 'Select a template type first' : 'Select Template'}</option>
                                            {templateOptions.map((template, index) => (
                                                <option key={index} value={JSON.stringify(template)}>{template.template_name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {/* Section 3 — Contacts */}
                            <div style={f.section}>
                                <div style={f.sectionHeader}>
                                    <span style={f.stepBadge}>3</span>
                                    <div>
                                        <p style={f.sectionTitle}>Send To</p>
                                        <p style={f.sectionDesc}>Choose how to provide the recipient list</p>
                                    </div>
                                </div>
                                <div style={f.sectionBody}>
                                    <div style={f.fieldGroup}>
                                        <label style={f.label}>Send Via</label>
                                        <div style={f.radioGroup}>
                                            {SEND_VIA_OPTIONS.map((opt) => (
                                                <label key={opt.value} style={{ ...f.radioPill, ...(sendVia === opt.value ? f.radioPillActive : {}) }}>
                                                    <input
                                                        type="radio"
                                                        name="sendVia"
                                                        value={opt.value}
                                                        checked={sendVia === opt.value}
                                                        onChange={(e) => setSendVia(e.target.value)}
                                                        style={{ display: 'none' }}
                                                    />
                                                    <i className={`bi ${opt.icon}`} style={{ marginRight: 6, fontSize: 12 }}></i>
                                                    {opt.label}
                                                </label>
                                            ))}
                                        </div>
                                    </div>

                                    {/* One to One */}
                                    {sendVia === 'oneToOne' && (
                                        <div style={f.fieldGroup}>
                                            <label style={f.label}>Contact Numbers <span style={f.required}>*</span></label>
                                            <input
                                                type="text"
                                                id="oneToOneInput"
                                                style={{ ...f.input, ...(noError ? f.inputError : {}) }}
                                                placeholder="e.g. 9876543210,9876543211"
                                                value={noInput}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setNoInput(value.replace(/[^0-9,]/g, ''));
                                                    const regex = /^(\d{10},)*\d{10}$/;
                                                    const values = value.split(',').filter(Boolean);
                                                    if (values.length > 10) setNoError('Maximum 10 mobile numbers allowed.');
                                                    else if (!regex.test(value)) setNoError('Invalid format. Use 10-digit numbers separated by commas.');
                                                    else setNoError('');
                                                }}
                                            />
                                            {noError && <span style={f.fieldError}>{noError}</span>}
                                            <span style={f.hint}>10-digit numbers starting with 6, 7, 8 or 9 · Max 10 numbers · Separated by commas</span>
                                        </div>
                                    )}

                                    {/* Contact List */}
                                    {sendVia === 'contactList' && (
                                        <div style={f.fieldGroup}>
                                            <label style={f.label}>Select Contact List <span style={f.required}>*</span></label>
                                            <select id="contactlist" style={f.input} value={contactList} onChange={(e) => setContactList(e.target.value)} required>
                                                <option value="">Select List</option>
                                                {listOptions.map((list, index) => (
                                                    !list.file_def && list.contact_type !== 'Segment' &&
                                                    <option key={index} value={list._id}>{list.group_name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )}

                                    {/* Segment List */}
                                    {sendVia === 'segmentList' && (
                                        <div style={f.fieldGroup}>
                                            <label style={f.label}>Select Segment <span style={f.required}>*</span></label>
                                            <select id="segmentlist" style={f.input} value={segmentList} onChange={(e) => setSegmentList(e.target.value)} required>
                                                <option value="">Select Segment</option>
                                                {listOptions.map((list, index) => (
                                                    !list.file_def && list.contact_type === 'Segment' &&
                                                    <option key={index} value={list._id}>{list.group_name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )}

                                    {/* File Upload */}
                                    {sendVia === 'fileUpload' && (
                                        <div style={f.fieldGroup}>
                                            <label style={f.label}>Upload File <span style={f.required}>*</span></label>
                                            <input type="file" id="fileUploadInput" style={f.fileInput} required />
                                            <span style={f.hint}>Upload a CSV or TXT file containing contact numbers</span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Section 4 — Schedule */}
                            <div style={f.section}>
                                <div style={f.sectionHeader}>
                                    <span style={f.stepBadge}>4</span>
                                    <div>
                                        <p style={f.sectionTitle}>Schedule</p>
                                        <p style={f.sectionDesc}>Send now or schedule for later</p>
                                    </div>
                                </div>
                                <div style={f.sectionBody}>
                                    <div style={f.fieldGroup}>
                                        <label style={f.label}>When to Send</label>
                                        <div style={f.radioGroup}>
                                            {SCHEDULE_OPTIONS.map((opt) => (
                                                <label key={opt.value} style={{ ...f.radioPill, ...(scheduleOption === opt.value ? f.radioPillActive : {}) }}>
                                                    <input
                                                        type="radio"
                                                        name="scheduleOption"
                                                        value={opt.value}
                                                        checked={scheduleOption === opt.value}
                                                        onChange={(e) => setScheduleOption(e.target.value)}
                                                        style={{ display: 'none' }}
                                                    />
                                                    <i className={`bi ${opt.icon}`} style={{ marginRight: 6, fontSize: 12 }}></i>
                                                    {opt.label}
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                    {scheduleOption === 'schedule' && (
                                        <div style={f.scheduleRow}>
                                            <div style={{ flex: 1 }}>
                                                <label style={f.label}>Date <span style={f.required}>*</span></label>
                                                <input
                                                    type="date"
                                                    id="scheduleDate"
                                                    style={f.input}
                                                    value={scheduleDate}
                                                    onChange={(e) => setScheduleDate(e.target.value)}
                                                    min={new Date().toISOString().split('T')[0]}
                                                    required
                                                />
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <label style={f.label}>Time <span style={f.required}>*</span></label>
                                                <input
                                                    type="time"
                                                    id="scheduleTime"
                                                    style={f.input}
                                                    value={scheduleTime}
                                                    onChange={(e) => setScheduleTime(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Submit */}
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                                <button type="button" style={f.btnSecondary} onClick={() => navigate('/campaign')}>Cancel</button>
                                <button type="submit" style={f.btnPrimary} disabled={isSubmitting}>
                                    {isSubmitting
                                        ? <><span style={f.spinner}></span> Creating…</>
                                        : <><i className="bi bi-send" style={{ marginRight: 8 }}></i>Create Campaign</>}
                                </button>
                            </div>
                        </div>

                        {/* ── RIGHT COLUMN — Template Preview ─────── */}
                        <div style={f.rightCol}>
                            <div style={f.previewSticky}>
                                <p style={f.previewLabel}>
                                    <i className="bi bi-phone" style={{ marginRight: 6, color: '#1565c0' }}></i>
                                    Template Preview
                                </p>
                                <div style={f.waPhone}>
                                    <div style={f.waBar}>
                                        <div style={f.waAvatar}><i className="bi bi-whatsapp" style={{ fontSize: 14 }}></i></div>
                                        <span style={f.waName}>WhatsApp Preview</span>
                                    </div>
                                    <div style={f.waBody}>
                                        {selectedTemplate ? (
                                            <TemplateViewComponent template={JSON.parse(selectedTemplate)} />
                                        ) : (
                                            <div style={f.waEmpty}>
                                                <i className="bi bi-layout-text-window-reverse" style={{ fontSize: 28, color: '#9ca3af' }}></i>
                                                <p style={{ margin: 0, fontSize: 12, color: '#9ca3af', textAlign: 'center' }}>Select a template to see preview</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <ToastContainer />
            </div>
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </WrapperComponent>
    );
};

const f = {
    page: { display: 'flex', flexDirection: 'column', gap: 16, fontFamily: "'Segoe UI', system-ui, sans-serif" },
    pageHeader: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 },
    pageTitle: { margin: 0, fontSize: '20px', fontWeight: '700', color: '#111827' },
    pageSubtitle: { margin: '2px 0 0', fontSize: '13px', color: '#6b7280' },
    layout: { display: 'flex', gap: 20, alignItems: 'flex-start' },
    leftCol: { flex: 2, display: 'flex', flexDirection: 'column', gap: 16, minWidth: 0 },
    rightCol: { width: 300, flexShrink: 0 },
    previewSticky: { position: 'sticky', top: 16 },
    section: { background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb', overflow: 'hidden', boxShadow: '0 1px 6px rgba(0,0,0,0.04)' },
    sectionHeader: { display: 'flex', alignItems: 'flex-start', gap: 12, padding: '16px 20px', background: '#f8fafc', borderBottom: '1px solid #f3f4f6' },
    stepBadge: { width: 28, height: 28, borderRadius: '50%', background: 'linear-gradient(to right, #2388e0, #1565c0)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, flexShrink: 0 },
    sectionTitle: { margin: 0, fontSize: '14px', fontWeight: '700', color: '#111827' },
    sectionDesc: { margin: '2px 0 0', fontSize: '12px', color: '#6b7280' },
    sectionBody: { padding: '20px', display: 'flex', flexDirection: 'column', gap: 16 },
    fieldGroup: { display: 'flex', flexDirection: 'column', gap: 5 },
    label: { fontSize: '13px', fontWeight: '600', color: '#374151' },
    required: { color: '#ef4444', marginLeft: 2 },
    input: { padding: '9px 12px', fontSize: '14px', border: '1.5px solid #d1d5db', borderRadius: '8px', outline: 'none', width: '100%', boxSizing: 'border-box', color: '#111827', fontFamily: 'inherit', background: 'white' },
    inputError: { borderColor: '#ef4444' },
    fieldError: { fontSize: '12px', color: '#ef4444' },
    hint: { fontSize: '11px', color: '#9ca3af' },
    fileInput: { padding: '8px 10px', fontSize: '13px', border: '1.5px solid #d1d5db', borderRadius: '8px', outline: 'none', width: '100%', boxSizing: 'border-box' },
    radioGroup: { display: 'flex', gap: 8, flexWrap: 'wrap' },
    radioPill: { display: 'inline-flex', alignItems: 'center', padding: '7px 14px', border: '1.5px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', color: '#374151', fontWeight: '500', userSelect: 'none' },
    radioPillActive: { border: '1.5px solid #1565c0', background: '#eff6ff', color: '#1565c0' },
    scheduleRow: { display: 'flex', gap: 12 },
    previewLabel: { fontSize: '12px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 10 },
    waPhone: { borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', border: '6px solid #1a1a2e' },
    waBar: { background: '#075e54', padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10 },
    waAvatar: { width: 30, height: 30, borderRadius: '50%', background: '#25d366', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', flexShrink: 0 },
    waName: { color: 'white', fontSize: '13px', fontWeight: '600' },
    waBody: { background: '#ece5dd', padding: '12px', minHeight: 200 },
    waEmpty: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '40px 20px' },
    btnPrimary: { display: 'inline-flex', alignItems: 'center', padding: '10px 24px', background: 'linear-gradient(to right, #2388e0, #1565c0)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' },
    btnSecondary: { display: 'inline-flex', alignItems: 'center', padding: '8px 14px', background: '#f3f4f6', color: '#374151', border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' },
    spinner: { width: '15px', height: '15px', border: '2px solid rgba(255,255,255,0.3)', borderTopColor: 'white', borderRadius: '50%', display: 'inline-block', animation: 'spin 0.7s linear infinite', marginRight: 6 },
};

export default CreateCampaignComponent;
